import { BroadcastChannelController } from '@/lib/broadcast-channel';

type AlertLiveViewEventSidecar =
  | {
    type: 'alert-changed';
    alertId: string;
  }
  | {
    type: 'alert-closed';
  };

export const AlertLiveViewSidecarController = new BroadcastChannelController<
  unknown,
  AlertLiveViewEventSidecar
>('AlertLiveViewSidecar');
